/**
 * SidebarLayout
 * Flex-row container that places the sidebar alongside the main content area.
 * Provides the mobile hamburger button with a menu icon.
 */

import type { ReactNode } from 'react';
import './Sidebar.css';

interface SidebarLayoutProps {
  sidebar: ReactNode;
  children: ReactNode;
  mobileOpen: boolean;
  onToggleMobile: () => void;
}

export function SidebarLayout({ sidebar, children, mobileOpen, onToggleMobile }: Readonly<SidebarLayoutProps>) {
  return (
    <div className="sidebar-layout">
      {sidebar}
      <div className="sidebar-content">
        {children}
      </div>
      {!mobileOpen && (
        <button
          type="button"
          className="sidebar-hamburger"
          onClick={onToggleMobile}
          aria-label="Open navigation"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="17" y2="12" />
            <line x1="3" y1="18" x2="13" y2="18" />
          </svg>
          <span>Steps</span>
        </button>
      )}
    </div>
  );
}
